module.exports = __webpack_public_path__ + "img/img_cx3_open.4df58c7b.jpg";